import React from 'react';
import { useTranslation } from 'react-i18next';
import TimeIcon from '../assets/time.svg';
import CapIcon from '../assets/capa.svg';
import LinkIcon from '../assets/link.svg';
import '../styles/experts.css';

const EXPERT_LINKS = [
  'https://www.linkedin.com/in/heimerrojas/?locale=en_US',
  'https://www.linkedin.com/in/abdel-perez-url/',
];

const EXPERT_IMG_CLASSES = ['experts-img1', 'experts-img2'];

const Experts = () => {
  const { t } = useTranslation();
  const profiles = t('experts.profiles', { returnObjects: true });

  return (
    <section className="bg-white flex flex-col" id="experts">
      <div className="divider-conteiner text-center space-y-0 mb:space-y-2">
        <h1 className="font-sans text-secondary font-bold resp-h3">
          {t('experts.title')}
        </h1>
        <p className="hero-p resp-h2" style={{ lineHeight: "130%" }}>
          {t('experts.subtitle')}
        </p>
      </div>

      <div className="experts-container" style={{ paddingTop: '5rem' }}>
        {profiles.map((profile, idx) => (
          <div key={idx} className="experts-card">
            <div className={`experts-card-image ${EXPERT_IMG_CLASSES[idx]}`}></div>
            <div className="experts-card-header">
              <h2 className="experts-card-title">{profile.name}</h2>
              <p className="experts-card-subtitle">{profile.role}</p>
            </div>
            <div className="experts-card-body">
              <p className="experts-card-text">{profile.description}</p>
              <div className="experts-subcontainer-group">
                <div className="experts-subcontainer">
                  <img src={TimeIcon} alt="Time Icon" className="experts-icon" />
                  <div className="experts-text-container">
                    <span className="experts-text-title">{profile.years}</span>
                    <span className="experts-text-subtitle">{t('experts.years_experience')}</span>
                  </div>
                </div>
                <div className="experts-subcontainer">
                  <img src={CapIcon} alt="Cap Icon" className="experts-icon" />
                  <div className="experts-text-container">
                    <span className="experts-text-title">{profile.trainings_count}</span>
                    <span className="experts-text-subtitle">{t('experts.trainings')}</span>
                  </div>
                </div>
              </div>
              <div className="experts-subcontainer-3">
                <div className="experts-shape">
                  <a href={EXPERT_LINKS[idx]} target="_blank" rel="noopener noreferrer" className="experts-social-link">
                    <img src={LinkIcon} alt="LinkedIn" className="experts-social-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experts;
